<script lang="ts">
	import ProductAddedToCartDrawer from '$lib/components/Drawer/ProductAddedToCartDrawer.svelte';
	import { globalAddedToCartStore } from '$lib/store/globalAddedToCart.store';

	const expanded = globalAddedToCartStore.expanded;
</script>

<ProductAddedToCartDrawer lineIds={$globalAddedToCartStore.lineIDs} bind:expanded={$expanded} />
